import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import cx from 'classnames';
import _ from 'lodash';

import styles from '../components.module.scss';
import { Row, Col } from "react-bootstrap";
import Truncate from "react-truncate";

import { fetchAllNDATemplates } from 'actions/links';

export default function NDAList({onNDASelection}) {
    const dispatch = useDispatch();

    const loading = useSelector((state) => _.get(state, 'links.nda.loading'));
    const templates = useSelector((state) => _.get(state, 'links.nda.templates'));

    useEffect(() => {
        dispatch(fetchAllNDATemplates());
    }, []);

    const handleSelect = (item) => {
      onNDASelection(item);
    }

    return(

      <div className={styles.ndaContent}>
        {templates && templates.length > 0 && 
          <NDASignatureList ndaTemplates={templates} onSelect={(template) => handleSelect(template)}/>
        }
        {templates && templates.length === 0 && 
          <EmptyMessage />
        }
      </div> 
    );

    function NDASignatureList({ndaTemplates, onSelect}){
      var ndaSignaturesList = ndaTemplates.map(template => {
        return (
          <Row key={template.id} className={cx(styles.signature)} onClick={() => onSelect(template)}>
            <Col md={12} className={styles.left}>
              <div className={styles.name}>
                <Truncate lines={1}> {template.name} </Truncate>
              </div>
            </Col>  
          </Row>
        )
      });
      return ndaSignaturesList;
    }

    function EmptyMessage(){
      return(
        <div className={styles.empty}>
          <h4>Type less, Share more!</h4>
          <p>Create reusable NDA templates for you and your teams.</p>
        </div>
      )
    }
}